import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, statusConvertor } from '../../utils/useful'

class TableStatusIndicator extends React.Component {
    state = {
        // status:{
        //     'C':{key:'C',label:'{{lang}}Connected',color:'#fff',backgroundColor:'007aff'},
        //     'P':{key:'P',label:'{{lang}}Pending',color:'#fff',backgroundColor:'#9ab'},
        //     'S':{key:'S',label:'{{lang}}Self',color:'#fff',backgroundColor:'#000'},
        // }
    }

   


    getInfo(data) {   
       
        return statusConvertor(data)

    }

    render() {
        return (
            <div className="w-100 h-100 flexc">
                <p className="text-capitalize font-size-12 text-semibold" style={{color: this.getInfo(this.props.data).color, backgroundColor: this.getInfo(this.props.data).backgroundColor, textOverflow: 'ellipsis', overflow: 'hidden', padding:'6px 14px',borderRadius:30 }}>{checkTranslation(this.getInfo(this.props.data).label)}</p>
            </div>
        )
    }
}

export default TableStatusIndicator;